export const Post = {
    sight: {
        type: 'sight',
        postType: 'sight',
        postsLabel: 'Sevärdheter',
        postLabel: 'Sevärdhet',
        newButtonLabel: 'Ny sevärdhet',
        icon: 'nature_people',
    },
    event: {
        type: 'event',
        postType: 'event',
        postsLabel: 'PAGE_EVENTS.EVENTS',
        postLabel: 'PAGE_EVENTS.EVENT',
        newButtonLabel: 'PAGE_EVENTS.NEW',
        icon: 'event',
    },
    occasion: {
        type: 'occasion',
        postType: 'occasion',
        postsLabel: 'PAGE_OCCASIONS.OCCASIONS',
        postLabel: 'PAGE_OCCASIONS.OCCASIONS',
        newButtonLabel: 'PAGE_OCCASIONS.NEW',
        icon: 'query_builder',
    },
    weekly_schedule: {
        type: 'weekschedule',
        postType: 'weekschedule',
        editComponent: 'week_post',
        postsLabel: 'PAGE_WEEKLY_SCHEDULE.SCHEDULE',
        postLabel: 'PAGE_WEEKLY_SCHEDULE.SCHEDULE',
        newButtonLabel: 'PAGE_WEEKLY_SCHEDULE.NEW',
        icon: 'event_note',
    },
    page: {
        type: 'page',
        postType: 'page',
        postsLabel: 'PAGE_PAGES.PAGES',
        postLabel: 'PAGE_PAGES.PAGE',
        newButtonLabel: 'PAGE_PAGES.NEW',
        icon: 'speaker_notes',
    },
    news: {
        type: 'news',
        postType: 'news',
        postsLabel: 'PAGE_NEWS.NEWS_MANY',
        postLabel: 'PAGE_NEWS.NEWS_ONE',
        newButtonLabel: 'PAGE_NEWS.NEW',
        icon: 'rss_feed',
        expand: 'client,meta,media',
    },
    lunch_week: {
        type: 'lunch_week',
        postType: 'lunch_week',
        editComponent: 'week_post',
        postsLabel: 'PAGE_FOOD.FOOD_MENU',
        postLabel: 'PAGE_FOOD.FOOD_MENU',
        newButtonLabel: 'PAGE_FOOD.NEW',
        icon: 'fastfood',
    },
    story: {
        type: 'story',
        postType: 'story',
        postsLabel: 'PAGE_STORIES.STORY',
        postLabel: 'PAGE_STORIES.STORIES',
        newButtonLabel: 'PAGE_STORIES.NEW',
        icon: 'book',
    },
    noticeboard: {
        type: 'noticeboard',
        postType: 'note',
        postsLabel: 'PAGE_NOTICEBOARD.NOTES_MANY',
        postLabel: 'PAGE_NOTICEBOARD.NOTE_ONE',
        newButtonLabel: 'PAGE_NOTICEBOARD.NEW',
        icon: 'assignment',
    },
    category: {
        type: 'category',
        postType: 'category',
        postsLabel: 'PAGE_CATEGORIES.CATEGORIES',
        postLabel: 'PAGE_CATEGORIES.CATEGORY',
        newButtonLabel: 'PAGE_CATEGORIES.NEW',
        icon: 'folder',
        route: 'categories',
        expand: 'meta,media',
        params: {
            stream: 'up',
        },
    },
    approute: {
        type: 'approute',
        postType: 'approute',
        postsLabel: 'PAGE_APP_LINKS.APP_LINKS',
        postLabel: 'PAGE_APP_LINKS.APP_LINK',
        newButtonLabel: 'PAGE_APP_LINKS.NEW',
        icon: 'touch_app',
    },
};
